import { translate } from '../../i18n/index.js';
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { marketingApi } from '../../api/marketing.api.js';
import { Spinner } from '../../components/design/AtomFitUI.js';

export function MarketingUnsubscribe() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const isTest = params.get('test') === '1';
  const [email, setEmail] = useState('');
  const [unsubscribed, setUnsubscribed] = useState(false);
  const [loading, setLoading] = useState(!isTest);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isTest) return;
    if (!token) {
      setError(
        translate('pages.public.marketing_unsubscribe.marketing_unsubscribe.set_error.copy'),
      );
      setLoading(false);
      return;
    }
    void marketingApi
      .unsubscribeStatus(token)
      .then((response) => {
        setEmail(response.data.email);
        setUnsubscribed(response.data.unsubscribed);
      })
      .catch(() =>
        setError(
          translate('pages.public.marketing_unsubscribe.marketing_unsubscribe.set_error.copy_2'),
        ),
      )
      .finally(() => setLoading(false));
  }, [token, isTest]);

  async function unsubscribe() {
    setLoading(true);
    setError(null);
    try {
      await marketingApi.unsubscribe(token);
      setUnsubscribed(true);
    } catch {
      setError(translate('pages.public.marketing_unsubscribe.unsubscribe.set_error.error'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <main
      className="af-screen"
      style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 20 }}
    >
      <section
        className="af-card"
        style={{ width: 'min(520px, 100%)', padding: 32, textAlign: 'center' }}
      >
        <img
          src="/brand/atomfit-logo-olive-horizontal.svg"
          alt={translate(
            'pages.public.marketing_unsubscribe.marketing_unsubscribe.img.alt_brand_name',
          )}
          width={150}
          style={{ marginBottom: 24 }}
        />

        {isTest ? (
          <>
            <h1 style={{ fontSize: 24 }}>
              {translate('pages.public.marketing_unsubscribe.marketing_unsubscribe.h1.email')}
            </h1>
            <p style={{ color: 'var(--af-muted)' }}>
              {translate(
                'pages.public.marketing_unsubscribe.marketing_unsubscribe.p.email_inactive',
              )}
            </p>
          </>
        ) : loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 30 }}>
            <Spinner />
          </div>
        ) : error ? (
          <div className="af-error">{error}</div>
        ) : unsubscribed ? (
          <>
            <h1 style={{ fontSize: 24 }}>
              {translate('pages.public.marketing_unsubscribe.marketing_unsubscribe.h1.heading')}
            </h1>
            <p style={{ color: 'var(--af-muted)', lineHeight: 1.6 }}>
              {translate('pages.public.marketing_unsubscribe.marketing_unsubscribe.p.address')}{' '}
              {email}{' '}
              {translate(
                'pages.public.marketing_unsubscribe.marketing_unsubscribe.p.booking_email_campaign',
              )}
            </p>
          </>
        ) : (
          <>
            <h1 style={{ fontSize: 24 }}>
              {translate(
                'pages.public.marketing_unsubscribe.marketing_unsubscribe.h1.logout_email_campaign',
              )}
            </h1>
            <p style={{ color: 'var(--af-muted)', lineHeight: 1.6 }}>
              {translate(
                'pages.public.marketing_unsubscribe.marketing_unsubscribe.p.address_confirmation',
              )}{' '}
              {email}
              {translate('pages.public.marketing_unsubscribe.marketing_unsubscribe.p.status')}
            </p>
            <button
              className="af-primary-btn"
              style={{ margin: '20px auto 0' }}
              onClick={() => void unsubscribe()}
            >
              {translate(
                'pages.public.marketing_unsubscribe.marketing_unsubscribe.button_primary_btn.confirmation',
              )}
            </button>
          </>
        )}
        <div style={{ marginTop: 24 }}>
          <Link to="/" style={{ color: 'var(--af-muted)', fontSize: 13 }}>
            {translate('pages.public.marketing_unsubscribe.marketing_unsubscribe.link.back')}
          </Link>
        </div>
      </section>
    </main>
  );
}
